import React, { useEffect, useState } from "react";
import { Card, Form, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { FormHelper } from "utils";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import Attachments from "components/Attachment/Attachment";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { ComprobanteElectronico } from "models/ECF/ComprobanteElectronico";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import useQueryParams from "hooks/useQueryParams";
import { Compania } from "models/Compania";
import { CompaniaManager, SolicitudCompaniaTenantManager as SolicitudManager } from "managers";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import DropZone from "components/DropZone/Dropzone";
import { useTheme, useApp } from "hooks";
import useConfirm from "hooks/useConfirm";
import {
  ESTATUS_RECHAZADO,
  ESTATUS_RECHAZADO_LABEL
} from "models/SolicitudesCompaniaTenant"
import { InputSidebarContainer } from "components";
import ModalContainer from "components/ModalContainer/ModalContainer";
import { useAuthentication } from "hooks";

const ESTATUS_LIST = Compania.ESTATUS_LIST;
const AMBIENTES_LIST = Compania.AMBIENTE_LIST;

export default function CompaniaEdit({ showLoading, hideLoading }) {
  const CITRUS_ID = 10;

  const [compania, setCompania] = useState({});
  const [solicitud, setSolicitud] = useState({});
  const [companiasTenant, setCompaniasTenant] = useState([]);
  const [tituloHeader, setTituloHeader] = useState("Crear Compañia");
  const [mostrarConfiguracionSistemaExterno, setMostrarConfiguracionSistemaExterno] = useState(false);
  const [showRechazoSolicitudModal, setShowRechazoSolicitudModal] = useState();
  const [razonRechazoSolicitud, setRazonRechazoSolicitud] = useState();
  const [showAdjuntarDocumentosModal, setShowAdjuntarDocumentosModal] = useState();
  const [modal, setModal] = useState(false);
  const [attachmentCount, setAttachmentCount] = useState(0);
  const { usuario } = useAuthentication();

  const URLParameters = useQueryParams();
  const Id = URLParameters.get("Id");
  const request = URLParameters.get("request") === "true";
  const requestDataParam = URLParameters.get("requestData");
  const requestData = request ? JSON.parse(atob(requestDataParam)) : null;
  const requestId = request ? requestData.Id : null;
  const requestCompaniaId = request ? requestData.CompaniaId : null;
  const esNuevo = !Id;
  const { Message, cerrarAlertas, Types, Warning } = useMessage();
  const { Confirm } = useConfirm();
  const { handleException } = useExceptionHandler();
  const { theme, vendorTheme } = useTheme();
  const { configuration } = useApp();
  const history = useHistory();

  useEffect(() => {
    if (usuario?.CompaniaId !== CITRUS_ID) {
      Warning({ message: "Usuario no tiene permiso" });
      return;
    }

    if (Id) {
      showLoading();
      cargarCompania(Id);
      setTituloHeader("Editar Compañia");
    } else if (request) {
      cargarFormularioCompania(requestId, requestCompaniaId);
    } else {
      setDefaultValues();
    }

    const companiasTenantWhere = {
      EsTenant: true,
      EsPaginable: false,
      Estatus: "A"
    };
    CompaniaManager.listado(companiasTenantWhere)
      .then((res) => {
        const companiasTenant = [
          { label: "N/A", value: null },
          ...(res.Data?.map((cia) => ({
            label: `${cia.RNC} - ${cia.Nombre}`,
            value: cia.Id
          })) || [])
        ];
        setCompaniasTenant(companiasTenant);
      })
      .catch((err) => handleException(err));

    hideLoading();
    cerrarAlertas();
    return () => { };
  }, []);

  useEffect(() => {
  }, [compania]);

  const setDefaultValues = () => {
    let color1 = "#F16101";
    let color2 = "#8AA8B0";
    let color3 = "#FFFFFF";

    if (theme.title == "GN ECF") {
      color1 = "#D52B1E";
      color2 = "#1097AF";
      color3 = "#FFFFFF";
    }

    setCompania({
      ...Compania,
      Estatus: Compania.DEFAULT_ESTATUS_VALUE,
      Ambiente: Compania.DEFAULT_AMBIENTE_VALUE,
      Nombre: "",
      RazonSocial: "",
      Codigo: "",
      RNC: "",
      DireccionLinea1: "",
      TelefonoPrincipal: "",
      TelefonoSecundario: "",
      Email: "",
      Color1: color1,
      Color2: color2,
      Color3: color3,
      PaginaWeb: "",
      Extension1: "",
      Extension2: "",
      Fax: "",
      ConfiguracionSistemaExterno: "",
      ClienteId: 0,
      EsPrincipal: false,
    });
    setMostrarConfiguracionSistemaExterno(false);
  };

  const setCheckedProp = (e) => {
    const { name, checked } = e.target;
    setCompania({
      ...compania,
      [name]: checked,
    });
  };

  const cargarFormularioCompania = (requestId, requestCompaniaId) => {
    const request = {
      IdSec: requestId,
      CompaniaId: requestCompaniaId
    }
    SolicitudManager.buscarSolicitudCompaniaTenantPorId(request).then((data) => {
      data.compania.Color1 = "#" + data.compania.Color1;
      data.compania.Color2 = "#" + data.compania.Color2;
      data.compania.Color3 = "#" + data.compania.Color3;

      setCompania(data.compania);
      setSolicitud(data.solicitud);
    });
  }

  const cargarCompania = (Id) => {

    CompaniaManager.buscarPorId(Id).then((data) => {
      data.Color1 = "#" + data.Color1;
      data.Color2 = "#" + data.Color2;
      data.Color3 = "#" + data.Color3;

      setCompania({ ...data, Id });
      // Si hay configuración de sistema externo, marcar el checkbox
      if (data.ConfiguracionSistemaExterno && data.ConfiguracionSistemaExterno.trim() !== "") {
        setMostrarConfiguracionSistemaExterno(true);
      }
    });
  };

  const onFileChange = (propFile, propName) => {
    setCompania({ ...compania, [propName]: propFile });
  };

  function handleCrearEnProduccion(forzarIdAutomatico = false) {
    showLoading();
    CompaniaManager.crearEnProduccion(Id, forzarIdAutomatico)
      .then((res) => {
        if (res?.yaExiste) {
          Warning({ message: "Esta compañía ya está creada en producción." });
        } else if (res?.nombreOcupado) {
          Warning({ message: "Ya existe una compañía con este nombre en producción." });
        } else if (res?.idOcupado) {
          Confirm({
            title: "ID en uso",
            textBody: "Este ID ya está en uso por otra compañía en producción. ¿Desea crearla de todas formas con un ID autogenerado?",
            onConfirm: () => handleCrearEnProduccion(true),
            confirmBtnText: "Sí, crear",
            cancelBtnText: "Cancelar",
            showCancel: true,
          });
        } else {
          Message({ message: "Compañía creada exitosamente en producción." });
        }
      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  }

  function grabar() {
    showLoading();

    if (esNuevo) {
      let companiaRequest = {
        ...compania
      }
      if (request) {
        companiaRequest = {
          ...companiaRequest,
          EsSolicitudTenant: request,
          SolicitudId: requestId,
          CompaniaSolicitanteId: requestCompaniaId
        }
        setCompania(companiaRequest);
      }
      CompaniaManager.crear(companiaRequest)
        .then((_res) => {
          Message({ message: `Grabado Exitosamente` });
          if (request) {
            let urlBase = `/SolicitudCompaniaTenantList`;
            history.push(urlBase);
          }
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    } else {
      setCompania({ ...compania, Id: Id });
      CompaniaManager.editar(compania)
        .then(() => {
          Message({ message: `Actualizado Exitosamente` });
          cargarCompania(res.Id);
        })
        .catch((e) => handleException(e))
        .finally(() => hideLoading());
    }
  }

  function rechazarSolicitud() {
    showLoading();

    if (request) {
      SolicitudManager
        .actualizarSolicitudCompaniaTenant({
          IdSec: requestId,
          CompaniaId: requestCompaniaId,
          Estatus: ESTATUS_RECHAZADO,
          RazonRechazoSolicitud: razonRechazoSolicitud
        })
        .then((res) => {
          Message({ message: "Solicitud rechazada exitosamente." });
        })
        .catch((err) => {
          handleException(err);
        })
        .finally(() => {
          hideLoading();
          setShowRechazoSolicitudModal(false);
          let urlBase = `/SolicitudCompaniaTenantList`;
          history.push(urlBase);
        });
    }
  }

  const rechazarSolicitudModal = (
    <ModalContainer
      showModal={showRechazoSolicitudModal}
      size="lg"
      title="Rechazar Solicitud"
      btnGrabar={{
        label: "Grabar",
        show: true
      }}
      cerrar={() => {
        setShowRechazoSolicitudModal(false);
      }}
      grabar={() => {
        rechazarSolicitud();
      }}
    >
      <EditSection>
        <Row>
          <InputSidebarContainer label="Razón de rechazo">
            <Form.Control
              as="textarea"
              rows={5}
              style={{ resize: "vertical" }}
              disabled={false}
              value={razonRechazoSolicitud}
              onChange={(e) =>
                setRazonRechazoSolicitud(e.target.value)
              }
            >
            </Form.Control>
          </InputSidebarContainer>
        </Row>
      </EditSection>
    </ModalContainer>
  )

  const adjuntarDocumentoModal = (
    <ModalContainer
      showModal={showAdjuntarDocumentosModal}
      size="lg"
      title="Adjuntar Documentos"
      btnGrabar={{
        show: false
      }}
      cerrar={() => {
        setShowAdjuntarDocumentosModal(false);
      }}
    >
      <EditSection>
        <Attachments
          readonly={true}
          showLoading={() => { }}
          hideLoading={() => { }}
          companiaId={solicitud.CompaniaId}
          fuente="SolicitudesCompaniaTenant"
          modulo="ECF"
          referencia={requestId}
          ocultarHeader={true}
          modal={modal}
          setModal={setModal}
          setAttachmentCount={setAttachmentCount}
        />
      </EditSection>
    </ModalContainer>
  )

  return (
    <>
      {request && showRechazoSolicitudModal && rechazarSolicitudModal}
      {request && showAdjuntarDocumentosModal && adjuntarDocumentoModal}

      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo={`${tituloHeader}`}
            volver={true}
            grabar={grabar}
            {...request && { rechazar: () => setShowRechazoSolicitudModal(true) }}
            {...request && { adjuntarDocumento: () => setShowAdjuntarDocumentosModal(true) }}
            {...(!esNuevo && !configuration?.EsProduccion && { crearEnProduccion: handleCrearEnProduccion })}
          />
          <EditContainer>
            <EditSection title="Información General">
              <SectionRow>
                <InputContainer label="Id">
                  <Form.Control
                    type="number"
                    name="Id"
                    value={compania.Id}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Nombre">
                  <Form.Control
                    type="text"
                    name="Nombre"
                    value={compania.Nombre}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Razón Social">
                  <Form.Control
                    type="text"
                    name="RazonSocial"
                    value={compania.RazonSocial}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Código">
                  <Form.Control
                    type="text"
                    name="Codigo"
                    value={compania.Codigo}
                    onChange={(e) =>
                      FormHelper.handleChangeNoEspace(e, setCompania)
                    }
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="RNC">
                  <Form.Control
                    type="text"
                    name="RNC"
                    value={compania.RNC}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Dirección">
                  <Form.Control
                    type="text"
                    name="DireccionLinea1"
                    value={compania.DireccionLinea1}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Teléfono Principal">
                  <Form.Control
                    type="text"
                    name="TelefonoPrincipal"
                    value={compania.TelefonoPrincipal}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>
                <InputContainer label="Extensión 1">
                  <Form.Control
                    type="text"
                    name="Extension1"
                    value={compania.Extension1}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Teléfono Secundario">
                  <Form.Control
                    type="text"
                    name="TelefonoSecundario"
                    value={compania.TelefonoSecundario}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>

                <InputContainer label="Extensión 2">
                  <Form.Control
                    type="text"
                    name="Extension2"
                    value={compania.Extension2}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Correo">
                  <Form.Control
                    type="text"
                    name="Email"
                    value={compania.Email}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
                <InputContainer label="Fax">
                  <Form.Control
                    type="text"
                    name="Fax"
                    value={compania.Fax}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                  />
                </InputContainer>
              </SectionRow>
              <SectionRow>
                <InputContainer label="Página Web">
                  <Form.Control
                    type="text"
                    name="PaginaWeb"
                    value={compania.PaginaWeb}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>
            <EditSection title="Apariencia">
              <EditSection title="Color" mt={"mt-5"}>
                <SectionRow triple={true}>
                  <InputContainer label="Primario" labelSize={3}>
                    <Form.Control
                      name="Color1"
                      type="color"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Color1}
                    />
                  </InputContainer>
                  <InputContainer
                    label="Secundario"
                    labelSize={3}
                    labelClassName="pl-2 d-flex"
                  >
                    <Form.Control
                      name="Color2"
                      type="color"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Color2}
                    />
                  </InputContainer>
                  <InputContainer label="Logo">
                    <Form.Control
                      name="Color3"
                      type="color"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Color3}
                    />
                  </InputContainer>
                </SectionRow>
              </EditSection>
            </EditSection>
            <EditSection title="Configuración">
              <div className="d-flex">
                <Form.Check
                  className="divContainer ml-2 mt-2"
                  type="checkbox"
                  aria-label="Manejar Secuencias Fiscales Automaticamente"
                  onChange={setCheckedProp}
                  id="chkManejarSecuenciasFiscalesAutomaticamente"
                  name="ManejarSecuenciasFiscalesAutomaticamente"
                  checked={compania.ManejarSecuenciasFiscalesAutomaticamente}
                />
                <label
                  htmlFor="chkManejarSecuenciasFiscalesAutomaticamente"
                  style={{ width: "450px" }}
                  className="mt-2"
                >
                  Manejar Secuencias Fiscales Automaticamente
                </label>
              </div>
              <div className="d-flex">
                <Form.Check
                  className="divContainer ml-2 mt-2"
                  type="checkbox"
                  aria-label="No permitir Duplicado Numero Factura Interna"
                  onChange={setCheckedProp}
                  id="chkNoPermitirDuplicadoFacturaInterna"
                  name="NoPermitirDuplicadoFacturaInterna"
                  checked={compania.NoPermitirDuplicadoFacturaInterna}
                />
                <label
                  htmlFor="chkNoPermitirDuplicadoFacturaInterna"
                  style={{ width: "450px" }}
                  className="mt-2"
                >
                  No permitir Duplicado Numero Factura Interna
                </label>
              </div>
              <div className="d-flex">
                <Form.Check
                  className="divContainer ml-2 mt-2"
                  type="checkbox"
                  aria-label="Agregar Configuración de Sistema Externo"
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setMostrarConfiguracionSistemaExterno(checked);
                    // Si se desmarca el checkbox y hay datos, limpiar el campo
                    if (!checked && compania.ConfiguracionSistemaExterno) {
                      setCompania({
                        ...compania,
                        ConfiguracionSistemaExterno: ""
                      });
                    }
                  }}
                  id="chkMostrarConfiguracionSistemaExterno"
                  checked={mostrarConfiguracionSistemaExterno}
                />
                <label
                  htmlFor="chkMostrarConfiguracionSistemaExterno"
                  style={{ width: "450px" }}
                  className="mt-2"
                >
                  Agregar Configuración de Sistema Externo
                </label>
              </div>
              {mostrarConfiguracionSistemaExterno && (
                <SectionRow>
                  <InputContainer label="Configuración Sistema Externo">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="ConfiguracionSistemaExterno"
                      value={compania.ConfiguracionSistemaExterno || ""}
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      placeholder="Ingrese la configuración JSON del sistema externo..."
                    />
                  </InputContainer>
                </SectionRow>
              )}
              <SectionRow>
                <InputContainer label="Cantidad de Transacciones">
                  <Form.Control
                    type="number"
                    name="CantidadTransacciones"
                    value={compania.CantidadTransacciones}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    style={{ width: '125px' }}
                  />
                </InputContainer>

                <InputContainer label="Cliente Id">
                  <Form.Control
                    type="number"
                    name="ClienteId"
                    value={compania.ClienteId}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    style={{ width: '125px' }}
                  />
                </InputContainer>
                <div className="d-flex">
                  <Form.Check
                    className="divContainer ml-2 mt-2"
                    type="checkbox"
                    aria-label="Es Principal"
                    onChange={setCheckedProp}
                    id="chkEsPrincipal"
                    name="EsPrincipal"
                    checked={compania.EsPrincipal}
                  />
                  <label
                    htmlFor="chkEsPrincipal"
                    style={{ width: "450px" }}
                    className="mt-2"
                  >
                    Es Principal
                  </label>
                </div>
              </SectionRow>
            </EditSection>
            <EditSection >
              <SectionRow>
                <InputContainer label="Cantidad de PT">
                  <Form.Control
                    type="number"
                    name="CantidadPT"
                    value={compania.CantidadPT}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    style={{ width: '125px' }}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>
            <br />
            <EditSection title="Vinculación">
              <SectionRow>
                <div className="d-flex">
                  <Form.Check
                    className="divContainer ml-2 mt-2"
                    type="checkbox"
                    aria-label="Es Padre"
                    onChange={setCheckedProp}
                    id="chkEsTenant"
                    name="EsTenant"
                    checked={compania.EsTenant}
                    disabled={request}
                  />
                  <label
                    htmlFor="chkEsTenant"
                    style={{ width: "450px" }}
                    className="mt-2"
                  >
                    Es Padre
                  </label>
                </div>
              </SectionRow>
              {!(compania.EsTenant ?? false) &&
                <SectionRow>
                  <InputContainer label="Compañía Padre">
                    <Select
                      isDisabled={request}
                      className="react-select primary mb-2"
                      classNamePrefix="react-select"
                      name="CompaniaTenantId"
                      onChange={(e) => {
                        setCompania({
                          ...compania,
                          CompaniaTenantId: e.value
                        });
                      }}
                      options={companiasTenant}
                      value={companiasTenant.filter(c => c.value == compania.CompaniaTenantId)}
                    />
                  </InputContainer>
                </SectionRow>
              }
            </EditSection>
          </EditContainer>
        </Card>
      </Form >
    </>
  );
}
